"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const T1 = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2967_12428)" }, /* @__PURE__ */ React.createElement("path", { d: "M21.148 8.869V19H18.574V11.74L16.2145 12.8785V10.3705L19.366 8.869H21.148Z", fill: "currentcolor" }), /* @__PURE__ */ React.createElement("path", { d: "M3.624 6.952V4.264H16.2V6.952H11.448V19H8.352V6.952H3.624Z", fill: "currentcolor" })),
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2967_12428" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" })))
  );
};
export default T1;
